export default "__VITE_ASSET__abb004b1__"